import authFetch from "components/Authentication/AuthFetch"
const api_url = process.env.REACT_APP_DASHBOARD_API_URL;

export const deleteActivity = (userId, activityId) => {
  return authFetch(`${api_url}/api/athletes/${userId}/activities/${activityId}`, 'DELETE')
}

export const addActivity = (userId, activityDataInJSON) => {
  return authFetch(`${api_url}/api/athletes/${userId}/activities`, 'POST', JSON.stringify(activityDataInJSON))
}

export const editActivity = (userId, activityId, activityDataInJSON) => {
  return authFetch(`${api_url}/api/athletes/${userId}/activities/${activityId}`, 'PUT', JSON.stringify(activityDataInJSON))
}



// WEBPACK FOOTER //
// ./src/api/internal/activities.js